// Centralised lucide-react icon lookup. Admin settings store the icon name
// (string), UI looks it up here and falls back to a safe default.
import {
  Gift,
  Zap,
  ShieldCheck,
  Headphones,
  Trophy,
  Users,
  Gamepad2,
  Banknote,
  BadgeCheck,
  Lock,
  Scale,
  Star,
  Sparkles,
  Crown,
  Smartphone,
  MessageCircle,
  Mail,
  Phone,
  Send,
  Clock,
  Heart,
  Flame,
  Rocket,
  Target,
  Award,
  Percent,
} from "lucide-react";

const ICON_MAP = {
  Gift, Zap, ShieldCheck, Headphones, Trophy, Users, Gamepad2, Banknote,
  BadgeCheck, Lock, Scale, Star, Sparkles, Crown, Smartphone, MessageCircle,
  Mail, Phone, Send, Clock, Heart, Flame, Rocket, Target, Award, Percent,
};

export function resolveIcon(name, fallback = Sparkles) {
  if (!name) return fallback;
  return ICON_MAP[name] || fallback;
}

export const AVAILABLE_ICONS = Object.keys(ICON_MAP);
